import type { JSX } from 'react'

import { SettingsNestedPageContainerSC } from './SettingsNestedPageContainer.styled'

export interface ISettingsNestedPageContainerProps {
  children?: React.ReactNode
  maxWidth?: string
}

export const SettingsNestedPageContainer = ({
  children,
  maxWidth = '640px',
}: ISettingsNestedPageContainerProps): JSX.Element => {
  return (
    <SettingsNestedPageContainerSC maxWidth={maxWidth}>
      {children}
    </SettingsNestedPageContainerSC>
  )
}
